import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";

export const usePostKarteShare = () => {
  return useBoronMutation(
    async ({
      studentId,
      karteId,
      message,
    }: {
      studentId: string;
      karteId: string;
      message: string;
    }) =>
      await boronClient.POST(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}/share",
        {
          params: {
            path: {
              student_id: studentId,
              karte_hashid: karteId,
            },
          },
          body: { message },
        },
      ),
  );
};
